module.exports = __webpack_public_path__ + "img/Ryan_Yao.2f194c87.jpg";